export default "__VITE_ASSET__mJmQObvX__"